module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter7"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch7"
    }
  }, [_vm._v("Triple Mushroom Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Three different types of mushrooms slow cook in a bacon-and-sage broth to deliver a delicious soup to serve as a main course or starter. Make sure to check the expiration date on your dried mushrooms; if they are old, chances are they will take away from the flavor of the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8 strips bacon, cut into ½-inch dice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 large onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon dried sage leaves, crushed in the palm of your hand")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 pound cremini mushrooms, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 pound shiitake mushrooms, stems removed, caps sliced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 ounce dried porcini mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 cups chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 cup heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup snipped fresh chives for garnishing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("saute the bacon in a large skillet over medium heat until crisp and remove it from the pan to drain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("add the onion and sage to the pan and sauté until the onion is softened. Add the cremini and shiitake mushrooms and toss until the mixture is combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Add the porcini mushrooms, soy sauce, broth, and bacon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover and cook on high for 3 hours or on low for 5 to 6 hours. At the end of the cooking time, add the cream and stir to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serve the soup garnished with the chives.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v("slow-cooker savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you would like a smooth soup, purée with an immersion blender.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ceb5fd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013-chapter7.vue
// module id = 93
// module chunks = 0